import React from 'react'
import { RootState } from '../modules/reducers'
import { useSelector } from 'react-redux'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { createTheme } from '../theme'
import App from './App'

const ThemeContext = () => {
	const accessibility = useSelector((state: RootState) => state.accessibility)
	return(
		<MuiThemeProvider theme={createTheme(accessibility.isVisualHandicap)}>
			<App />
		</MuiThemeProvider>
	)
}

export default ThemeContext